// extracted by mini-css-extract-plugin
module.exports = {"small":"VerticalSpace_small__3Nbrh","normal":"VerticalSpace_normal__P2__U","large":"VerticalSpace_large__1Aa_9"};